import { cn } from 'lib/utils';
import { FC, ReactNode } from 'react';
import { cardPadding } from './Card';

const CardTitleBar: FC<{ children: ReactNode; isVideoCard?: boolean }> = ({
  children,
  isVideoCard = false,
}) => (
  <div
    className={cn(
      `grid absolute top-0 left-0 w-full ${isVideoCard ? 'grid-cols-[auto_auto] max-w-[85%] md:max-w-full' : 'grid-cols-[auto_1fr]'} @lg:gap-4 justify-between items-center z-10`,
      cardPadding.all
    )}
  >
    {children}
  </div>
);

export default CardTitleBar;
